import { createFileRoute, Outlet } from '@tanstack/react-router';

// No route guard: the parent /$slug beforeLoad already requires
// authentication; the department-manager check itself is reactive in the UI
// layer via usePermissions + authContext.managedDeptIds.
export const Route = createFileRoute('/$slug/department')({
  component: Outlet
});
